import {uniqueId} from 'underscore'

/**
 * @mixin
 */
export default {
    props: {
        /**
         * Position the element absolutely.
         */
        absolute: {
            type: Boolean,
            default: false
        },
        /**
         * Class bound whn the button is active.
         */
        activeClass: {
            type: String,
            default: 'v-btn--active'
        },
        /**
         * Vue Router router-link prop.
         */
        append: {
            type: Boolean,
            default: false
        },
        /**
         * Passes through v-on bindings to the v-btn component
         */
        bindVOn: {
            type: Object,
            default: undefined
        },
        /**
         * Expands the button to 100% of the available space.
         */
        block: {
            type: Boolean,
            default: false
        },
        /**
         * Align the component towards the bottom.
         */
        bottom: {
            type: Boolean,
            default: false
        },
        /**
         * Colour of the button.
         */
        color: {
            type: String,
            default: ''
        },
        /**
         * Applies the dark theme.
         */
        dark: {
            type: Boolean,
            default: false
        },
        /**
         * Removes the button box shadow.
         */
        depressed: {
            type: Boolean,
            default: false
        },
        /**
         * Disable the button.
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * Exactly match the link.
         * Note: without this, '/' will match every route.
         */
        exact: {
            type: Boolean,
            default: false
        },
        /**
         * Make buttons round
         */
        fab: {
            type: Boolean,
            default: false
        },
        /**
         * Position the element fixed.
         */
        fixed: {
            type: Boolean,
            default: false
        },
        /**
         * Removes the background background colour.
         */
        flat: {
            type: Boolean,
            default: false
        },
        /**
         * Designates the component tag to `<a>`
         */
        href: {
            type: [String, Object],
            default: undefined
        },
        /**
         * Makes the icon round and flat to hold an icon.
         * Note: this prop is set true if an `iconName` is provided.
         */
        icon: {
            type: Boolean,
            default: false
        },
        /**
         * Allows the icon colour to be set for icon provided by the `iconName` prop.
         */
        iconColor: {
            type: String,
            default: ''
        },
        /**
         * Makes the icon large (36px).
         */
        iconLarge: {
            type: Boolean,
            default: false
        },
        /**
         * Move the icon to the left side of the button.
         */
        iconLeft: {
            type: Boolean,
            default: false
        },
        /**
         * Makes the icon medium (28px).
         */
        iconMedium: {
            type: Boolean,
            default: false
        },
        /**
         * Specify the name of the icon to use for the button.
         * If provided, will place a `<v-icon>` component within the button to display the icon.
         */
        iconName: {
            type: String,
            default: ''
        },
        /**
         * Move the icon to the right side of the button.
         */
        iconRight: {
            type: Boolean,
            default: false
        },
        /**
         * Specifies a custom font size for the icon (px).
         */
        iconSize: {
            type: [Number, String],
            default: undefined
        },
        /**
         * Makes the icon small (16px).
         */
        iconSmall: {
            type: Boolean,
            default: false
        },
        /**
         * Makes the icon extra large (40px).
         */
        iconXLarge: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: undefined
        },
        /**
         * Controls the button active state.
         */
        inputValue: {
            type: Boolean,
            default: false
        },
        /**
         * Makes the button large.
         */
        large: {
            type: Boolean,
            default: false
        },
        /**
         * Align the component towards the left.
         */
        left: {
            type: Boolean,
            default: false
        },
        /**
         * Applies the light variant.
         */
        light: {
            type: Boolean,
            default: false
        },
        /**
         * Adds a loading icon animation in the button.
         */
        loading: {
            type: Boolean,
            default: false
        },
        /**
         * Specifies the link is a nuxt-link.
         */
        nuxt: {
            type: Boolean,
            default: false
        },
        /**
         * Applies an outline to the button.
         */
        outline: {
            type: Boolean,
            default: false
        },
        /**
         * Vue Router router-link prop.
         */
        replace: {
            type: Boolean,
            default: false
        },
        /**
         * Align the component towards the right.
         */
        right: {
            type: Boolean,
            default: false
        },
        /**
         * Applies the `v-ripple` directive
         */
        ripple: {
            type: [Boolean, Object],
            default: undefined
        },
        /**
         * Button will be round on the sides.
         */
        round: {
            type: Boolean,
            default: false
        },
        /**
         * Makes the button small.
         */
        small: {
            type: Boolean,
            default: false
        },
        /**
         * Specify a custom tag to use on the component.
         */
        tag: {
            type: String,
            default: 'button'
        },
        /**
         * Specify the target attribute.
         */
        target: {
            type: String,
            default: undefined
        },
        /**
         * Will designate the component tag to <router-link>.
         */
        to: {
            type: [String, Object],
            default: undefined
        },
        /**
         * Align the content towards the top.
         */
        top: {
            type: Boolean,
            default: false
        },
        /**
         * Set the button's type attribute.
         */
        type: {
            type: String,
            default: 'button'
        },
        /**
         * Display the button.
         */
        show: {
            type: Boolean,
            default: undefined
        }
    },
    methods: {
        handleButtonClick () {
            /**
             * Click event.
             * @type {undefined}
             */
            this.$emit('click')
        }
    }
}
